import {
  faApple,
  faFacebook,
  faGoogle,
  faInstagram,
  faReddit,
  faWaze,
  faWikipediaW,
} from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import LinkWithIcon from "@/components/links/LinkWithIcon";
import LinkWithText from "@/components/links/LinkWithText";

export const createLink = (og: [string, string]): LinkWithIcon => {
  let link: LinkWithIcon | LinkWithText = {
    text: og[0],
    url: og[1],
  };

  if (link.url.includes("apple")) {
    link = {
      ...link,
      icon: faApple,
    };
  } else if (link.url.includes("google") || link.url.includes("goo.gl")) {
    link = {
      ...link,
      icon: faGoogle,
    };
  } else if (link.url.includes("instagram")) {
    link = {
      ...link,
      icon: faInstagram,
    };
  } else if (link.url.includes("wikipedia")) {
    link = {
      ...link,
      icon: faWikipediaW,
    };
  } else if (link.url.includes("waze")) {
    link = {
      ...link,
      icon: faWaze,
    };
  } else if (link.url.includes("reddit")) {
    link = {
      ...link,
      icon: faReddit,
    };
  } else if (link.url.includes("facebook")) {
    link = {
      ...link,
      icon: faFacebook,
    };
  } else {
    link = {
      ...link,
      icon: faLink,
    };
  }

  return link as LinkWithIcon;
};
